import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectorItem',
  props: {
  modelValue: {
    type: [String, Number],
    required: true
  },
  value: {
    type: [String, Number],
    required: true
  }
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', state: string | number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const active = computed(() => props.modelValue === props.value)

function click() {
  emit('update:modelValue', props.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { onClick: click }, [
    _renderSlot(_ctx.$slots, "default", { active: _unref(active) })
  ]))
}
}

})